<template>
  <div>
    <v-file-input accept="image/*" @change="onChange($event)" />
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  data: () => {},
  created() {},
  mounted() {},
  methods: {
    onChange(file) {
      let img = {
        src: "",
        alt: "",
      };
      let formData = new FormData();
      formData.append("file", file, file.name);

      // additional data
      formData.append("key", "file");

      this.axios
        .post("/upload", formData)
        .then((response) => {
          img.src = response.data.url;
          img.alt = file.name;

          this.$emit("select-file", img);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
});
</script>

<style lang="scss" scoped></style>
